import React from 'react';
import { Toaster } from 'react-hot-toast';

const ToastProvider: React.FC = () => {
  return (
    <Toaster
      position="top-right"
      reverseOrder={false}
      gutter={8}
      containerClassName=""
      containerStyle={{}}
      toastOptions={{
        duration: 4000,
        style: {
          background: 'var(--toast-default-bg)',
          color: 'var(--toast-default-text)',
        },
        success: {
          duration: 3000,
          style: {
            background: 'var(--toast-success-bg)',
            color: 'var(--toast-success-text)',
          },
        },
        error: {
          duration: 5000,
          style: {
            background: 'var(--toast-error-bg)',
            color: 'var(--toast-error-text)',
          },
        },
      }}
    />
  );
};

export default ToastProvider;
